/* ============================================================
   cluburban
   ============================================================ */

export const platjadesitges = {
    id: "6",
    type: "playlist",
    featured: true,
    title: "Platja de Sitges",
    link: "platja-de-sitges",
    playlistBg: "rgb(255, 171, 38)",
    imgUrl: "../image/listas/platja-de-sitges/movin-to-the-sun.jpg",  // /image/set/listas/playa.jpeg
    hoverColor: "rgb(255, 171, 38)",
    artist: "mixtape",
    artistImgUrl: "../image/set/mixtape.jpg",
    artistBio: "mixtape",
    artistDownload: "Descargar",
    bannerUno: "",
    downloadData: [],
    playlistImages: [],
    playlistData: [
      {
        id: "12",
        songName: "Adiós Amor / Oye Mujer",
        songimg: "../image/listas/platja-de-sitges/adios-amor-oye-mujer.jpg",
        songArtist: "Ke personajes",
        artistLink: "",
        link: "https://dl.dropbox.com/scl/fi/sk6pn4sue2uiwj0bvxrgy/Ke-personajes-Adi-s-Amor-_-Oye-Mujer.mp3?rlkey=7zp1s63u1rtghj4s7ttagqwru&st=vxbenidi&dl=1",
        trackTime: "06:48",
        index: 0,
        genre: "cumbia",
        genres: ["cumbia", "urban"],
      },
      {
        id: "2",
        songName: "Las Estrellitas De Plata (Tangos)",
        songimg: "../image/listas/platja-de-sitges/las-estrellitas-de-plata-(tangos).jpg",
        songArtist: "Chiquetete",
        artistLink: "",
        link: "https://dl.dropbox.com/scl/fi/xfrc2ree8lizymmsci1g0/Chiquetete-Las-Estrellitas-De-Plata-Tangos.mp3?rlkey=yt26l4yq6aa1u8ufu1bx34zp7&st=baabr281&dl=1",
        trackTime: "02:58",
        index: 1,
        genre: "flamenco",
        genres: ["flamenco", "tangos"],
      },
      {
        id: "3",
        songName: "After",
        songimg: "../image/listas/platja-de-sitges/after.jpg",
        songArtist: "Conep",
        artistLink: "",
        link: "https://dl.dropbox.com/scl/fi/06ehf0lvgd8rorawvbzrc/Conep-After.mp3?rlkey=w9fpl3w0gd8a9bjzh6nt7h0d1&st=bg8h3ic7&dl=1",
        trackTime: "02:47",
        index: 2,
        genre: "reggaeton",
        genres: ["latin", "urban"],
      },
      {
        id: "4",
        songName: "Por la boca vive el pez",
        songimg: "../image/listas/platja-de-sitges/por-la-boca-vive-el-pez.jpg",
        songArtist: "Fito y Fitipaldis",
        artistLink: "",
        link: "https://dl.dropbox.com/scl/fi/33dge8n0tva8cwbs33y20/Fito-y-Fitipaldis-Por-la-boca-vive-el-pez.mp3?rlkey=fvb85utktcmxp7654f699icff&st=pj9k1alo&dl=1",
        trackTime: "04:29",
        index: 3,
        genre: "rock",
        genres: ["latin", "rock"],
      },
      {
        id: "5",
        songName: "Mi Estrella Blanca",
        songimg: "../image/listas/platja-de-sitges/mi-estrella-blanca.jpg",
        songArtist: "Fondo Flamenco",
        artistLink: "",
        link: "https://dl.dropbox.com/scl/fi/2mlyl93putbly1juu3h8c/Fondo-Flamenco-Mi-Estrella-Blanca.mp3?rlkey=6hlgs2ywl9wuftz3qwyildgdm&st=mqa3vnji&dl=1",
        trackTime: "04:39",
        index: 4,
        genre: "flamenco",
        genres: ["flamenco", "tangos"],
      },
      {
        id: "6",
        songName: "Movin' To The Sun",
        songimg: "../image/listas/platja-de-sitges/movin-to-the-sun.jpg",
        songArtist: "HUGEL",
        artistLink: "",
        link: "https://dl.dropbox.com/scl/fi/34svgwt7uta5sq9yzxgb7/HUGEL-Movin-To-The-Sun.mp3?rlkey=7q8vyhvgx7pwwiy136cz2tox8&st=5cdl0vs3&dl=1",
        trackTime: "02:22",
        index: 5,
        genre: "house",
        genres: ["house", "urban"],
      },
      {
        id: "7",
        songName: "Beauty And A Beat",
        songimg: "../image/listas/platja-de-sitges/beauty-and-a-beat.jpg",
        songArtist: "Justin Bieber",
        artistLink: "",
        link: "https://dl.dropbox.com/scl/fi/cq552g74xs415j1nqoysm/Justin-Bieber-Beauty-And-A-Beat.mp3?rlkey=ojvcyb9nzif16oetb125h2etq&st=cyjuboli&dl=1",
        trackTime: "03:48",
        index: 6,
        genre: "pop",
        genres: ["urban", "pop"],
      },
      {
        id: "8",
        songName: "Dark Horse",
        songimg: "../image/listas/platja-de-sitges/dark-horse.jpg",
        songArtist: "Katy Perry",
        artistLink: "",
        link: "https://dl.dropbox.com/scl/fi/ca2hblofe9zo1cb5v4ccg/Katy-Perry-Dark-Horse.mp3?rlkey=acn0tdiv6ib6eo3fgp7nmvje9&st=an6vy2y1&dl=1",
        trackTime: "03:36",
        index: 7,
        genre: "pop",
        genres: ["urban", "pop"],
      },
      {
        id: "9",
        songName: "Hot N Cold",
        songimg: "../image/listas/platja-de-sitges/hot-n-cold.jpg",
        songArtist: "Katy Perry",
        artistLink: "",
        link: "https://dl.dropbox.com/scl/fi/ed5v9qllkmxxkh15rklho/Katy-Perry-Hot-N-Cold.mp3?rlkey=bsxiclfve2o1iptsxj9wbewne&st=vt6fvnla&dl=1",
        trackTime: "03:43",
        index: 8,
        genre: "pop",
        genres: ["urban", "pop"],
      },
      {
        id: "10",
        songName: "I Kissed A Girl",
        songimg: "../image/listas/platja-de-sitges/i-kissed-a-girl.jpg",
        songArtist: "Katy Perry",
        artistLink: "",
        link: "https://dl.dropbox.com/scl/fi/t60bsqxi0efe0448jigkd/Katy-Perry-I-Kissed-A-Girl.mp3?rlkey=kggjzsjj75hq0b8caoc509b77&st=6wdulaii&dl=1",
        trackTime: "03:00",
        index: 9,
        genre: "pop",
        genres: ["urban", "pop"],
      },
      {
        id: "11",
        songName: "Roar",
        songimg: "../image/listas/platja-de-sitges/roar.jpg",
        songArtist: "Katy Perry",
        artistLink: "",
        link: "https://dl.dropbox.com/scl/fi/8fb85hmrya2lu3u4wyu2i/Katy-Perry-Roar.mp3?rlkey=bad1yxdaa717ln7rszwzzd9sg&st=udcl9kmv&dl=1",
        trackTime: "03:44",
        index: 10,
        genre: "pop",
        genres: ["urban", "pop"],
      },
      {
        id: "13",
        songName: "Poker Face",
        songimg: "../image/listas/platja-de-sitges/poker-face.jpg",
        songArtist: "Lady Gaga",
        artistLink: "",
        link: "https://dl.dropbox.com/scl/fi/avrn027ffa2ktrxr8wlqd/Lady-Gaga-Poker-Face.mp3?rlkey=4lol168cm16hhzdtxbouxn5tr&st=k99c1kb3&dl=1",
        trackTime: "03:57",
        index: 11,
        genre: "pop",
        genres: ["urban", "pop"],
      },
      {
        id: "14",
        songName: "La Llama del Amor (Riega Este Querer - Rumba_Alborea)",
        songimg: "../image/listas/platja-de-sitges/la-llama-del-amor-(riega-este-querer---rumba:alborea).jpg",
        songArtist: "Omar Montes",
        artistLink: "",
        link: "https://dl.dropbox.com/scl/fi/q7wiwxoqm98oa3q6risht/Omar-Montes-La-Llama-del-Amor-Riega-Este-Querer-Rumba_Alborea.mp3?rlkey=qb7nje4pet3uhnalqxwqqi0d7&st=us7tk7o0&dl=1",
        trackTime: "02:58",
        index: 12,
        genre: "urban",
        genres: ["flamenco", "pop"],
      },
      {
        id: "15",
        songName: "Merengue Electronico (Rompe Consola)",
        songimg: "../image/listas/platja-de-sitges/merengue-electronico-(rompe-consola).jpg",
        songArtist: "Omega",
        artistLink: "",
        link: "https://dl.dropbox.com/scl/fi/bownmlzfxrieiytgom4al/Omega-Merengue-Electronico-Rompe-Consola.mp3?rlkey=fgeetinyr80huqsbokdip96qq&st=yga59gve&dl=1",
        trackTime: "03:52",
        index: 13,
        genre: "urban",
        genres: ["urban", "pop"],
      }
    ]
}
